
interface RazorpayOptions {
    key: string;
    amount: string;
    currency: string;
    name: string;
    description: string;
    image: string;
    order_id: string;
    callback_url: string;
    cancel_url: string;
    prefill: {
        name: string;
        email: string;
        contact: string;
    };
    notes: {
        entityId?: string
        entity?: string
        orderNo?: string
        enrolmentNo?: string;
        amount?: string;
    };
    theme: {
        color: string;
    };
}

// Load Razorpay script dynamically
const loadRazorpayScript = () => {
    return new Promise<void>((resolve) => {
        if (document.getElementById("razorpay-script")) {
            resolve();
            return;
        }
        const script = document.createElement("script");
        script.src = "https://checkout.razorpay.com/v1/checkout.js";
        script.id = "razorpay-script";
        script.onload = () => resolve();
        document.body.appendChild(script);
    });
};

const submitForm = async (options: RazorpayOptions) => {
    await loadRazorpayScript();
    const rzp1 = new (window as any).Razorpay(options);
    rzp1.open();
};


export const submitFormRazorpay = (data: any, currency: string) => {
    const options: RazorpayOptions = {
        amount: data.formData.amount,
        callback_url: data.formData.callback_url,
        cancel_url: data.formData.cancel_url,
        description: data.formData.description,
        image: '/media/logos/logo.png',
        key: data.formData.key_id,
        name: data.formData.name,
        currency: currency || "INR",
        notes: {
            amount: data.formData["notes[amount]"],
            enrolmentNo: data.formData["notes[enrolmentNo]"],
            entityId: data.formData["notes[entityId]"],
            entity: data.formData["notes[entity]"],
            orderNo: data.formData["notes[orderNo]"]
        },
        order_id: data.formData.order_id,
        prefill: {
            name: data.formData.name,
            email: data.formData["prefill[email]"],
            contact: data.formData["prefill[contact]"]
        },
        theme: {
            color: "#3399cc"
        }
    };

    submitForm(options)
    return Promise.resolve();
}
